import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=79ab26af"
import script from "./ViewCustomer.vue?vue&type=script&lang=js"
export * from "./ViewCustomer.vue?vue&type=script&lang=js"
import style0 from "./ViewCustomer.vue?vue&type=style&index=0&id=79ab26af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports